import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const Subtitle = styled.div`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleHeading
      : textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  margin-bottom: 8px;
`;
